"use client";

import { c as _c } from "react/compiler-runtime";
import { ErrorPageBody } from "./shared/error-page-body";

/**
 * Unlike 404.page.tsx before it, this file cannot set a document title: error
 * boundaries have to be client components, which rules out both `metadata` and
 * a plain `<title>` (the latter would be added to the one from app/layout.tsx
 * rather than replace it). The title thus stays the site-wide default.
 */
export default function Error() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorPageBody statusCode={500} message="unknown error" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}